/**
 * The words chosen at the foot of a lesson reach the reading (lesson-ending
 * DESIGN.md §3, frame 7, 2026-10-27). A reply tapped or words typed under
 * the lesson travel in memory (never the URL); the reading opens with the
 * Mystic's own lesson opener (server reference "lesson-opener"), and then
 * those words go as the seeker's first message, so the first thing in the
 * chat is what they read at the bottom of the lesson, already answered.
 */

const said = (m) => !!m && m.type === 'user'

/** Send now? The opener is in, nothing in flight, the box open, and the
 *  seeker has said nothing yet (the words are the FIRST message). */
export function firstWordsDue({ pending, messages, fetching, composerVisible } = {}) {
  if (!pending || !String(pending.words || '').trim()) return false
  if (fetching || !composerVisible) return false
  const ms = Array.isArray(messages) ? messages : []
  const at = ms.findIndex((m) => m && m._ref === 'lesson-opener')
  if (at < 0) return false
  return !ms.slice(at + 1).some(said)
}

/** A tapped reply is the opener's own starter: the same action as tapping it
 *  in the chat. Typed words that match nothing are a typed line. */
export function starterAction(quickActions, words) {
  const w = String(words || '').trim()
  if (!w || !Array.isArray(quickActions)) return null
  return quickActions.find((a) => a && a.lesson_starter && String(a.button_label || '').trim() === w) || null
}

/** Once the person has said something after the (latest) lesson opener, its
 *  starters are spent: one was used, or their own words went instead. The
 *  words chosen under the lesson go as soon as the opener's text is in, so
 *  its starters can land just after them (lesson ask path #3). */
export function startersSpent(messages) {
  const ms = Array.isArray(messages) ? messages : []
  let at = -1
  for (let i = ms.length - 1; i >= 0; i--) { if (ms[i] && ms[i]._ref === 'lesson-opener') { at = i; break } }
  return at >= 0 && ms.slice(at + 1).some(said)
}

/** The replies still offered: a spent opener's starters never come back, on
 *  the opener or under the Mystic's answer; the Mystic's next replies stay. */
export function liveReplies(actions, messages) {
  const list = Array.isArray(actions) ? actions : []
  if (!startersSpent(messages)) return list
  return list.filter((a) => !(a && a.lesson_starter))
}

/** start-session's `ask=1`: this visit is an Ask from the lesson just now
 *  (held in memory, never the address), so a repeat ask from the same lesson
 *  says the opener again; a reload of the address says nothing twice (#2). */
export function lessonAskParam(from, askFor) {
  return from && askFor && String(from) === String(askFor) ? '&ask=1' : ''
}
